export class User {
    id!: number;
    username!: string;
    signature: string | null = null;
    can_moderate_tab_submissions: boolean | null = null;
    suspected_bot: boolean | null = null;

    static fromObject(obj: Record<string, any>): User {
        return Object.setPrototypeOf(obj, User.prototype);
    }
}
